import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../../AppContext";
import { ICON_TRANSCRIBE } from "../../../constants/iconConstants";
import IconButton from "../../theme_reuse/IconButton";

interface Props {}

interface State {}

export default class OpenTranscriptionPopupButton extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  showMenu = () => {
    this.context.dispatch({ type: "ShowTranscriptionPopup" });
  };

  render(): ReactNode {
    return <IconButton mini title="Transcribe Chords" icon={ICON_TRANSCRIBE} onClick={this.showMenu} />;
  }
}

OpenTranscriptionPopupButton.contextType = AppContextType;
